module.exports = __webpack_public_path__ + "img/android-desktop.ae925618.png";